import axiosInstance from "./axiosInstance";

type ResendPayload = {
  email: string;
};

const resendVerificationCode = async ({email}: ResendPayload) => {
  try {
    const {data} = await axiosInstance.post("/resendVerificationCode", {email});
    return data;
  } catch (error: any) {
    if (error.response?.data?.message) {
      throw new Error(error.response.data.message);
    }
    throw new Error("Failed to resend verification code. Please try again.");
  }
};

export default resendVerificationCode;
